package one.healthium.profile.ui.update_height

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.UserModel

@Immutable
internal data class UpdateHeightUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
    val isMetric: Boolean = true,
    val updatedHeight: Float? = null,
) {
    val height = updatedHeight ?: userModel?.profile?.height
    val isHeightChanged = updatedHeight != null && updatedHeight != userModel?.profile?.height
    val isHeightValid = updatedHeight != null && updatedHeight >= 0 // TODO
}
